var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    className: "max-w-none",
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33338 15.1667H10.6667C13.3467 15.1667 13.8267 14.0933 13.9667 12.7867L14.4667 7.45333C14.6467 5.82667 14.18 4.5 11.3334 4.5H4.66671C1.82005 4.5 1.35338 5.82667 1.53338 7.45333L2.03338 12.7867C2.17338 14.0933 2.65338 15.1667 5.33338 15.1667Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 4.50065V3.96732C5.33334 2.78732 5.33334 1.83398 7.46668 1.83398H8.53334C10.6667 1.83398 10.6667 2.78732 10.6667 3.96732V4.50065",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33332 9.16667V9.83333C9.33332 9.84 9.33332 9.84 9.33332 9.84667C9.33332 10.5733 9.32666 11.1667 7.99999 11.1667C6.67999 11.1667 6.66666 10.58 6.66666 9.85333V9.16667C6.66666 8.5 6.66666 8.5 7.33332 8.5H8.66666C9.33332 8.5 9.33332 8.5 9.33332 9.16667Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4333 7.83398C12.8933 8.95398 11.1333 9.62065 9.33334 9.84732",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74661 8.01367C3.24661 9.04034 4.93995 9.66034 6.66661 9.85367",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIcon);
export default __webpack_public_path__ + "static/media/accountsIcon.255ed61d.svg";
export { ForwardRef as ReactComponent };